{
	/* Mi piacerebbe che ci fosse la copertina del video cliccabile che manda al canale di Youtube */
}
import {
	View,
	Text,
	Image,
	SafeAreaView,
	TouchableOpacity,
	ScrollView,
	ActivityIndicator,
} from "react-native";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import VideoCard from "../components/VideoCard";
// foto e loghi
import { Logo_mateMATTIci, PinguinoYouTubeImage } from "../assets";
import { MaterialCommunityIcons } from "@expo/vector-icons";
// for link
import { useCallback } from "react";
import { Alert, Linking } from "react-native";
// for YouTube APi
import firestore from "@react-native-firebase/firestore";
import { db } from "../utils/firebase";
import { doc, getDoc } from "firebase/firestore";

const OpenURLButton = ({ url, source_image }) => {
	const handlePress = useCallback(async () => {
		// Checking if the link is supported for links with custom URL scheme.
		const supported = await Linking.canOpenURL(url);

		if (supported) {
			// Opening the link with some app, if the URL scheme is "http" the web link should be opened
			// by some browser in the mobile
			await Linking.openURL(url);
		} else {
			Alert.alert(`Don't know how to open this URL: ${url}`);
		}
	}, [url]);
	return (
		<TouchableOpacity
			className="w-20 h-20 items-center justify-center"
			onPress={handlePress}
		>
			<Image
				source={source_image}
				className="w-full h-full object-cover flex-1"
			/>
		</TouchableOpacity>
	);
};

const MateMATTIci = () => {
	const navigation = useNavigation();

	const [isLoading, setIsLoading] = useState(true);
	const [videosData, setVideosData] = useState(null);
	const [nSubs, setNSubs] = useState(null);
	const [numberVideos, setNumberVideos] = useState(null);
	const [numberViews, setNumberViews] = useState(null);
	const videoTitle = [
		"Ultimi video:",
		"Video più rilevanti:",
		"Video più visti:",
	];

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	useEffect(() => {
		async function getVideos() {
			const docRef = doc(db, "youtube", "mateMATTIci-channel-info");
			const docSnap = await getDoc(docRef);

			if (docSnap.exists()) {
				// console.log(
				// 	"Document data:",
				// 	docSnap.data().date.items[1].snippet.channelTitle
				// );
				setVideosData(docSnap.data());
				setNSubs(
					docSnap.data().channel.items[0].statistics.subscriberCount
				);
				setNumberVideos(
					docSnap.data().channel.items[0].statistics.videoCount
				);
				setNumberViews(
					docSnap.data().channel.items[0].statistics.viewCount
				);
			} else {
				setVideosData(null);
			}
			setIsLoading(false);
		}
		if (isLoading) {
			getVideos();
		}
	}, []);

	return (
		<SafeAreaView className="flex-1 bg-[#263238] overflow-y-scroll">
			<View className="flex-row justify-around my-2">
				<OpenURLButton
					url="https://www.youtube.com/@mateMATTIci"
					source_image={Logo_mateMATTIci}
				/>
				<View className="flex-column space-y-1 justify-center">
					<Text className="font-bold text-xl text-white">
						mateMATTIci
					</Text>
					<Text className="font-semibold text-white">
						{nSubs ? `${nSubs} iscritti` : " "}
					</Text>
					<Text className="font-semibold text-white">
						{numberVideos ? `${numberVideos} video` : " "}
					</Text>
					{/* <Text className="font-semibold text-white">
						{numberViews} visualizzazioni
					</Text> */}
				</View>
				<View className="items-center justify-center">
					<Image
						source={PinguinoYouTubeImage}
						className="flex-1 w-[80px] h-[120px]"
					/>
				</View>
			</View>
			<ScrollView className="flex-1 ml-2">
				{videosData ? (
					["date", "relevance", "viewCount"].map((s, index) => {
						const data = videosData[s];
						const sectionTitle = videoTitle[index];
						return (
							<View key={index}>
								<View className="mx-1">
									<Text className="text-xl font-bold text-white">
										{sectionTitle}
									</Text>
								</View>
								<ScrollView
									horizontal={true}
									showsHorizontalScrollIndicator={true}
								>
									{data.items.map((item, index) => {
										return (
											<VideoCard
												key={index}
												videoLink={`https://www.youtube.com/watch?v=${item.id.videoId}`}
												thumbnailLink={
													item.snippet.thumbnails.high
														.url
												}
												title={item.snippet.title}
												videoDate={
													item.snippet.publishTime
												}
											/>
										);
									})}
								</ScrollView>
							</View>
						);
					})
				) : (
					<View className="flex-1 items-center justify-center mt-64">
						<ActivityIndicator size={"large"} color="white" />
					</View>
				)}
			</ScrollView>
		</SafeAreaView>
	);
};

export default MateMATTIci;
